import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { Tab } from "@mui/material";
import React, { useEffect, useState } from "react";
import Summarydetails from "../Summarydetails";
import {
  CheckAvailabilityData,
  getPackageDetailsListing,
  HotelListDataById,
  SupplierUrl,
} from "../../axios";
import moment from "moment";
import HotelDetailSkeleton from "../../HotelDetails/HotelDetailSkeleton";
import ItineraryComponent from "./ItineraryComponent";
import { useDispatch, useSelector } from "react-redux";
// import Lightbox from "react-image-lightbox";
import {
  addDaysToDate,
  calculateTotalPrice,
  constant,
  dbDateFormat,
  displayDateFormat,
  findFreeCancellationDateAndPayLater,
  findRoomCancellationById,
  findRoomOptionById,
  generateDateRange,
  getDateDifference,
  guestCombinationSentence,
} from "./commonFunction";
import { Base64 } from "js-base64";
import {
  clearAdminPackageCart,
  setAdminPackageCart,
  setCustomerPackageDiscountPercentage,
  setPackageBasic_details,
} from "../../../redux/actions/actions";
import EmptyRowComponent from "./EmptyRowComponent";
import ImageGalleryComponent from "./HotelDetailsComponent/ImageGalleryComponent";

const PackageShowcase = () => {
  const dispatch = useDispatch();
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const defaultZoneval = urlParams.get("moreLocation");
  const guestCombination = urlParams.get("guestCombination");
  const getDateSelected = urlParams.get("dateselected");
  const _packageID = urlParams.get("package_id");
  const package_id = Base64.atob(_packageID);

  const [tabValue, setTabValue] = useState("1");
  const [summaryTabData, setSummaryTabData] = useState([]);
  const [packageName, setPackageName] = useState("");
  const [packageImage, setPackageImage] = useState("");
  const [packageData, setPackageData] = useState([]);
  const [DatesOfDay, setDatesOfDay] = useState([]);
  const [totalDays, setTotalDays] = useState("");
  const [itineraryDetails, setItineraryDetails] = useState([]);
  const [skeleton, setSkeleton] = useState(true);
  // const [galleryOpen, setGalleryOpen] = useState(false);
  // const [photoIndex, setPhotoIndex] = useState(null);

  const customerPackage = useSelector(
    (state) => state.adminPackageCart.customerPackage
  );

  const convertedToArrayGuestCombination = JSON.parse(
    JSON.parse(guestCombination)
  );

  const totalImages = [
    packageImage,
    ...customerPackage
      .map(({ child }) =>
        child
          .filter((x) => x.selected)
          .map(({ gallery }) => gallery)
          .flat(1)
      )
      .flat(1),
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const getAdminPackageDetailsListingData = await getPackageDetailsListing(
          package_id
        );

        if (
          getAdminPackageDetailsListingData &&
          getAdminPackageDetailsListingData !== "nopackage"
        ) {
          setPackageName(getAdminPackageDetailsListingData?.package_name);
          setPackageImage(getAdminPackageDetailsListingData?.package_image);

          const numberOfNights = parseInt(
            getAdminPackageDetailsListingData?.no_days
          );
          setTotalDays(numberOfNights);

          const datesToRender = generateDateRange(
            getDateSelected,
            numberOfNights
          );
          setDatesOfDay(datesToRender);

          const itineraryPlan = getAdminPackageDetailsListingData.itinerary_data[0].children.map(
            (item) => ({
              ...item,
              range: item.range.map((r) => {
                const findStartDateDiff = getDateDifference(
                  getAdminPackageDetailsListingData.start_date,
                  r.startDate
                );
                const startDate = addDaysToDate(
                  datesToRender[0],
                  findStartDateDiff
                );

                const findDaysDiff = getDateDifference(r.startDate, r.endDate);
                const endDate = addDaysToDate(startDate, findDaysDiff);

                return {
                  ...r,
                  startDate: startDate,
                  endDate: endDate,
                };
              }),
            })
          );
          setItineraryDetails(itineraryPlan);

          const packageDetails = {
            package_start_date: dbDateFormat(datesToRender[0]),
            package_end_date: dbDateFormat(
              datesToRender[datesToRender.length - 1]
            ),
            package_name: getAdminPackageDetailsListingData.package_name,
            package_description:
              getAdminPackageDetailsListingData.package_description,
            package_image: getAdminPackageDetailsListingData.package_image,
            package_guestCombination_sentence: guestCombinationSentence(
              convertedToArrayGuestCombination
            ),
            package_night: numberOfNights,
          };
          dispatch(setPackageBasic_details(packageDetails));

          if (getAdminPackageDetailsListingData.itinerary_package.length) {
            const prepareData = await Promise.all(
              getAdminPackageDetailsListingData.itinerary_package.map(
                async (packages, mainIndex) => {
                  const freeCancellationDate = findFreeCancellationDateAndPayLater(
                    getAdminPackageDetailsListingData
                      .freepackageCancellation[0],
                    datesToRender[0]
                  );
                  // console.log("freeCancellationDate", freeCancellationDate);

                  const childData = await Promise.all(
                    packages.sequence_data.map(async (_child) => {
                      const _itinerary_type = parseInt(_child.itinerary_type);
                      const findStartDateDiff = getDateDifference(
                        getAdminPackageDetailsListingData.start_date,
                        _child.start_date
                      );
                      const startDate = addDaysToDate(
                        datesToRender[0],
                        findStartDateDiff
                      );

                      if (_itinerary_type === 4) {
                        // accommodation
                        const findDaysDiff = getDateDifference(
                          _child.start_date,
                          _child.end_date
                        );
                        const endDate = addDaysToDate(startDate, findDaysDiff);

                        let price = _child.price;
                        let notAvailable = false;

                        let JsonState = {
                          defaultZoneval: _child.island,
                          startDate: dbDateFormat(startDate),
                          endDate: dbDateFormat(endDate),
                          guestCombination: JSON.parse(
                            getAdminPackageDetailsListingData.guest_combination
                          ),
                          accopage: 1,
                          accosize: 30,
                          IndexNumber: 0,
                          package_id: _child.package_id,
                        };
                        const response = await HotelListDataById(
                          Base64.btoa(_child.property_id),
                          JsonState
                        );

                        const hotelResponse = response[0];
                        const currentHotelData =
                          hotelResponse.hs_portal || hotelResponse.hotel_link;
                        // console.log("property_name", _child.property_name);
                        // console.log("property_id", _child.property_id);
                        // console.log("startDate", startDate);
                        // console.log("endDate", endDate);
                        // console.log("hotelResponse", hotelResponse);
                        // console.log("currentHotelData", currentHotelData);
                        // console.log("old price", price);
                        // console.log(
                        //   "rate_plan_id",
                        //   _child.room_rateplan[0].rate_plan_id
                        // );
                        const roomOption = findRoomOptionById(
                          currentHotelData,
                          _child.room_rateplan[0].rate_plan_id
                        );
                        // console.log("roomOption", roomOption);

                        // const hotelCancellationPolicy = findRoomCancellationById(
                        //   currentHotelData,
                        //   _child.room_rateplan[0].rate_plan_id
                        // );

                        // const hotelFreeCancellationDate = findRoomFreeCancellationById(
                        //   currentHotelData,
                        //   _child.room_rateplan[0].rate_plan_id,
                        //   startDate
                        // );

                        if (roomOption) {
                          price = roomOption.AmountWithUplift;
                          // console.log("new price", price);
                        } else {
                          notAvailable = true;
                        }
                        // console.log("notAvailable", notAvailable);

                        const roomCancellation = findRoomCancellationById(
                          currentHotelData,
                          _child.room_rateplan[0].rate_plan_id,
                          startDate
                        );
                        // console.log("roomCancellation", roomCancellation);

                        return {
                          ..._child,
                          // ...(mainIndex === 0 ? packageDetails : {}),
                          itinerary_type: _itinerary_type,
                          packageId: _child.package_id,
                          property_id: _child.property_id,
                          property_room_id: _child.property_room_id,
                          rate_plan_id: _child.rate_plan_id,
                          price: price,
                          start_date: startDate,
                          end_date: endDate,
                          adult_count: _child.room_rateplan[0].adult_count,
                          child_count: _child.room_rateplan[0].child_count,
                          room_count: _child.room_rateplan[0].room_count,
                          cart_data: _child.room_rateplan,
                          name: _child.property_name,
                          image: _child.gallery_image[0],
                          gallery: _child.gallery_image,
                          address: `${_child.address_line_1} ${_child.island}`,
                          startDate: startDate,
                          endDate: endDate,
                          checkIn: _child.check_in,
                          checkOut: _child.check_out,
                          roomName: _child.room_rateplan
                            ?.map((x) => x.room_name)
                            ?.join(", "),
                          not_available: notAvailable,
                          cancellationpolicy: roomCancellation.roomCancellation,
                          firstcancellationdate: freeCancellationDate.date,
                          paylater: freeCancellationDate.paylater,
                          hotelData: hotelResponse,
                        };
                      } else {
                        // experience
                        const response = await CheckAvailabilityData(
                          [
                            {
                              adultCounter: _child.adult,
                              infantCounter: _child.infant,
                              childCounter: _child.child,
                              youthCounter: _child.youth,
                              seniorCounter: _child.senior,
                              groupCounter: _child.group,
                            },
                          ],
                          startDate,
                          _child.experience_id,
                          _child.price_typeid
                        );

                        let price = _child.price;
                        let notAvailable = false;
                        // console.log("tour_name", _child.tour_name);
                        // console.log("experience_id", _child.experience_id);
                        // console.log("startDate", startDate);
                        // console.log("old price", price);

                        const findRespondData =
                          response?.options &&
                          Array.isArray(response.options) &&
                          response.options.length > 0;
                        // console.log("findRespondData", findRespondData);

                        if (findRespondData) {
                          // console.log("response.options", response.options);
                          const finalFilterResponse = response.options.find(
                            (x) => x.id === _child.tour_price_schedule_id
                          );
                          // console.log(
                          //   "finalFilterResponse",
                          //   finalFilterResponse
                          // );
                          if (finalFilterResponse) {
                            price = calculateTotalPrice(
                              finalFilterResponse,
                              parseInt(_child.group),
                              parseInt(_child.adult),
                              parseInt(_child.infant),
                              parseInt(_child.child),
                              parseInt(_child.youth),
                              parseInt(_child.senior)
                            );
                            // console.log("new price", price);
                          } else {
                            notAvailable = true;
                          }
                        } else {
                          notAvailable = true;
                        }
                        // console.log("notAvailable", notAvailable);

                        return {
                          ..._child,
                          // ...(mainIndex === 0 ? packageDetails : {}),
                          itinerary_type: _itinerary_type,
                          experience_id: _child.experience_id,
                          plan_id: _child.plan_id,
                          price: (price ?? 0).toString(),
                          experience_date: _child.start_date,
                          experience_time: _child.experience_time,
                          packageId: _child.package_id,
                          experience_adult: _child.adult,
                          experience_child: _child.child,
                          experience_infant: _child.infant,
                          experience_youth: _child.youth,
                          experience_senior: _child.senior,
                          experience_group: _child.group,
                          price_typeid: _child.price_typeid,
                          name: _child.tour_name,
                          image: _child.gallery_image[0],
                          gallery: _child.gallery_image,
                          address: _child.tour_location,
                          start_date: startDate,
                          option_name: _child.option_name,
                          not_available: notAvailable,
                          cancellationpolicy: _child.tour_cancellation_policy,
                          firstcancellationdate: freeCancellationDate.date,
                          paylater: freeCancellationDate.paylater,
                        };
                      }
                    })
                  );

                  const filteredChildData = childData.filter((x) => x !== null);

                  return {
                    itinerary_type: parseInt(
                      packages.sequence_data[0].itinerary_type
                    ),
                    child: filteredChildData,
                  };
                }
              )
            );

            dispatch(setAdminPackageCart(prepareData));
            dispatch(
              setCustomerPackageDiscountPercentage(
                parseFloat(
                  getAdminPackageDetailsListingData.discount_percentage
                ) || 0
              )
            );
          }
          setPackageData(getAdminPackageDetailsListingData);

          if (getAdminPackageDetailsListingData?.summary) {
            const sortedData = getAdminPackageDetailsListingData?.summary
              ?.map((item, index) => ({ index, ...item }))
              ?.sort((a, b) => {
                const accodata = a.check_in
                  ? moment(a.check_in, "HH:mm a").toDate()
                  : null;
                const accodatb = b.check_in
                  ? moment(b.check_in, "HH:mm a").toDate()
                  : null;

                if (accodata === null && accodatb === null) {
                  return a.index - b.index;
                }
                if (accodata === null) return 1;
                if (accodatb === null) return -1;

                return accodata - accodatb;
              })
              ?.map(({ index, ...item }) => item);

            const resultSummaryData = [];
            datesToRender.length > 0 &&
              datesToRender.map((sequenceDate) => {
                resultSummaryData.push({
                  label: moment(sequenceDate).format("DD MMM Y"),

                  content: (
                    <div class="dayplan-wrapper" data-testid="day-plan-wrapper">
                      {Array.isArray(sortedData) &&
                        sortedData.length > 0 &&
                        sortedData.map((item, index) => {
                          let DataValue = "";
                          const findStartDateDiff = getDateDifference(
                            getAdminPackageDetailsListingData.start_date,
                            item.start_date
                          );
                          const startDate = addDaysToDate(
                            datesToRender[0],
                            findStartDateDiff
                          );
                          const dateSelected = new Date(startDate);

                          if (item.TYPE !== "accommodation") {
                            if (
                              moment(dateSelected).format("Y-MM-DD") ===
                              moment(sequenceDate).format("Y-MM-DD")
                            ) {
                              DataValue = (
                                <div className="dayRowContainer" key={index}>
                                  <div className="summaryDetailWrapper">
                                    <div className="summaryDetailContainer">
                                      <span className="font12 hotel-row-text-date-summary">
                                        <b>
                                          {item?.check_in
                                            ? item?.check_in
                                            : "Coordinated Timing"}
                                        </b>
                                      </span>
                                      <span className="font12">
                                        {item?.time ? (
                                          <>
                                            {item?.service_name}{" "}
                                            {item?.full_address}
                                          </>
                                        ) : (
                                          <>
                                            Coordinated Timing for{" "}
                                            <b>{item?.service_name}</b>{" "}
                                            {item?.full_address}: The supplier
                                            will contact you to organize.
                                          </>
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          } else {
                            const startDate = moment(item.start_date).format(
                              "Y-MM-DD"
                            );
                            const endDate = moment(item.end_date).format(
                              "Y-MM-DD"
                            );
                            const seqDate = moment(sequenceDate).format(
                              "Y-MM-DD"
                            );

                            if (startDate <= seqDate && endDate > seqDate) {
                              if (startDate === seqDate) {
                                DataValue = (
                                  <div className="dayRowContainer" key={index}>
                                    <div className="summaryDetailWrapper">
                                      <div className="summaryDetailContainer">
                                        <p className="font12 hotel-row-text-date-summary">
                                          <b>
                                            {moment(item.check_in, [
                                              "h:mm A",
                                            ]).format("hh A")}
                                          </b>
                                        </p>
                                        <span className="font12">
                                          Check-in to <b>{item.service_name}</b>{" "}
                                          {item.full_address}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                );
                              }
                            } else if (endDate === seqDate) {
                              DataValue = (
                                <div className="dayRowContainer" key={index}>
                                  <div className="summaryDetailWrapper">
                                    <div className="summaryDetailContainer">
                                      <p className="font12 hotel-row-text-date-summary">
                                        <b>
                                          {moment(item.check_out, [
                                            "h:mm A",
                                          ]).format("hh A")}
                                        </b>
                                      </p>
                                      <span className="font12">
                                        Check-out from{" "}
                                        <b>{item.service_name}</b>{" "}
                                        {item.full_address}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          }

                          return DataValue;
                        })}
                    </div>
                  ),
                });
              });
            setSummaryTabData(resultSummaryData);
          }
        } else {
          dispatch(clearAdminPackageCart());
          setPackageData([]);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setSkeleton(false);
      }
    };

    fetchData();
  }, []);

  // const setImagePhotoIndex = (index) => {
  //   setGalleryOpen(true);
  //   setPhotoIndex(index);
  // };

  let CancellationModalHS = (id, data) => {
    if (!data || data === "no_cancellationPolicy") return null;
    let DataNew = "";
    let Value = "";
    let EuroIcon = "";
    let PerIcon = "";
    return (
      <>
        {data.map((i, index) => {
          const date = new Date(getDateSelected);
          date.setDate(date.getDate() - parseInt(i.day_before_arrival));

          DataNew = displayDateFormat(date);

          if (i.penalty == "No Penalty") {
            Value = 0;
            EuroIcon = "";
            PerIcon = "";
          } else if (i.penalty == "Full Amount") {
            Value = "";
            EuroIcon = "";
            PerIcon = "Full booking amount will be charged.";
          } else if (i.penalty == "Percentage") {
            Value = i.cancellation_value;
            EuroIcon = "";
            PerIcon = "% of booking amount will be charged.";
          } else if (i.penalty == "Nights") {
            Value = i.cancellation_value;
            EuroIcon = <span>{constant.currencySign}</span>;
            PerIcon = " amount will be charged.";
          } else if (i.penalty == "Fixed Amount") {
            Value = i.cancellation_value;
            EuroIcon = <span>{constant.currencySign}</span>;
            PerIcon = " amount will be charged.";
          }

          if (i.day_before_arrival == 1) {
            DataNew = "In case of no show";
          }

          if (id == i.rate_plan_id) {
            return (
              <div className="cncpolicyTbl__row" key={index}>
                <div className="cncpolicyTbl__col">
                  {index == 0 ? "Before" : "After"} &#x202A;{DataNew}&#x202C;
                </div>
                <div className="cncpolicyTbl__col">
                  {/* Charge {Value}% of booking amount will be charged */}
                  {EuroIcon} {Value}
                  {PerIcon}
                </div>
              </div>
            );
          } else {
            return (
              <div className="cncpolicyTbl__row" key={index}>
                <div className="cncpolicyTbl__col">
                  {index == 0 ? "Before" : "After"} &#x202A;{DataNew}&#x202C;
                </div>
                <div className="cncpolicyTbl__col">
                  {/* Charge {Value}% of booking amount will be charged */}
                  {EuroIcon} {Value}
                  {PerIcon}
                </div>
              </div>
            );
          }
        })}
      </>
    );
  };

  if (skeleton) return <HotelDetailSkeleton marginTop={10} />;

  if (
    packageData.length === 0 ||
    customerPackage.length === 0 ||
    customerPackage.some((x) => x.child.length === 0)
  )
    return <EmptyRowComponent />;

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12 mb-3">
          <h2 className="fw-bold mb-1">
            {packageName}
            {"  "}
            <sup className="border h6 px-2 py-0 fw-bold rounded text-muted">
              {`${totalDays}N/${totalDays + 1}D`}
            </sup>
          </h2>
          <div className="d-flex text-muted gap-2 flex-wrap">
            <div className="fw-bold border px-2 py-0 rounded">
              <i
                className="fa fa-map-signs text-warning me-2"
                aria-hidden="true"
              ></i>
              {itineraryDetails.length > 0 &&
                itineraryDetails.map(({ name, Location }, index) => (
                  <React.Fragment key={index}>
                    {`${name}N ${Location?.label || ""}`}
                    {index < itineraryDetails.length - 1 && (
                      <span className="black-dot"></span>
                    )}
                  </React.Fragment>
                ))}
            </div>
            <div className="fw-bold border px-2 py-0 rounded">
              <i
                className="fa fa-users text-warning me-2"
                aria-hidden="true"
              ></i>
              {guestCombinationSentence(convertedToArrayGuestCombination)}
            </div>
          </div>
        </div>
      </div>
      <ImageGalleryComponent totalImages={totalImages} />
      {/* <div className="row h-100 p-3">
        {totalImages.length > 0 && (
          <>
            <div
              className="col-12 col-md-6"
              onClick={() => setImagePhotoIndex(0)}
            >
              <img
                src={totalImages[0]}
                className="w-100 h-100 cursor-pointer"
                alt="Additional Image 1"
                style={{ maxHeight: 400 }}
              />
            </div>
            {totalImages.length > 1 && (
              <div class="col-12 col-md-6 d-flex flex-wrap">
                {totalImages.slice(1, 5).map((image, index) => (
                  <div
                    key={index}
                    class="col-6"
                    onClick={() => setImagePhotoIndex(index + 1)}
                  >
                    {index === 3 ? (
                      <div
                        class="card text-white w-100 h-100 cursor-pointer"
                        onClick={() => setGalleryOpen(true)}
                      >
                        <img
                          src={image}
                          className="w-100 h-100 cursor-pointer ps-1 pt-1"
                          alt="Additional Image 5"
                          style={{ maxHeight: 200 }}
                        />
                        {totalImages.length > 5 && (
                          <div class="card-img-overlay d-flex justify-content-center align-items-center bg-dark bg-opacity-50 m-0 ms-1 my-1 ps-1 pt-1">
                            <p class="text-center h5 m-0 text-white">
                              +{totalImages.length - 5} Photos
                            </p>
                          </div>
                        )}
                      </div>
                    ) : (
                      <img
                        src={image}
                        className={`w-100 h-100 cursor-pointer ${
                          index === 0
                            ? "pe-1 pb-1"
                            : index === 1
                            ? "ps-1 pb-1"
                            : index === 2
                            ? "pe-1 pt-1"
                            : ""
                        }`}
                        style={{ maxHeight: 200 }}
                        alt={`Additional Image ${index + 1}`}
                      />
                    )}
                  </div>
                ))}
              </div>
            )}
          </>
        )}

        {galleryOpen && (
          <Lightbox
            mainSrc={totalImages[photoIndex]}
            nextSrc={totalImages[(photoIndex + 1) % totalImages?.length]}
            prevSrc={
              totalImages[
                (photoIndex + totalImages?.length - 1) % totalImages.length
              ]
            }
            onCloseRequest={() => setGalleryOpen(false)}
            onMovePrevRequest={() =>
              setPhotoIndex(
                (photoIndex + totalImages.length - 1) % totalImages.length
              )
            }
            onMoveNextRequest={() =>
              setPhotoIndex((photoIndex + 1) % totalImages.length)
            }
            wrapperClassName="ImageModal"
          />
        )}
      </div> */}
      <div className="row">
        <TabContext value={tabValue}>
          <div
            className="col-md-12 position-sticky bg-white"
            style={{ top: 70, zIndex: 5 }}
          >
            <TabList onChange={(_, value) => setTabValue(value)}>
              <Tab className="fw-bold" label="Package" value="1" />
              <Tab className="fw-bold" label="Description" value="4" />
              <Tab className="fw-bold" label="Policies" value="2" />
              <Tab className="fw-bold" label="Summary" value="3" />
            </TabList>
          </div>
          <div className="col-md-12" style={{ minHeight: "50vh" }}>
            <TabPanel className="px-0" value="1">
              <ItineraryComponent
                DatesOfDay={DatesOfDay}
                packageData={packageData}
                itineraryDetails={itineraryDetails}
                defaultZoneval={defaultZoneval}
                guestCombination={guestCombination}
              />
            </TabPanel>
            <TabPanel value="4">
              <div
                dangerouslySetInnerHTML={{
                  __html: packageData.package_description,
                }}
              />
            </TabPanel>
            <TabPanel className="px-0" value="2">
              <h5 className="mb-3">Cancellation Policy:</h5>
              <div className="cncpolicyTbl">
                <div className="cncpolicyTbl__head">
                  <div className="cncpolicyTbl__col">Date</div>
                  <div className="cncpolicyTbl__col">Fee</div>
                </div>

                {CancellationModalHS(
                  packageData.id,
                  packageData?.cancellation?.cancellation_policy
                )}
              </div>
            </TabPanel>
            <TabPanel className="p-0" value="3">
              <Summarydetails summaryTabData={summaryTabData} />
            </TabPanel>
          </div>
        </TabContext>
      </div>
    </div>
  );
};

export default PackageShowcase;
